import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { AppProviders } from './providers/app-providers';
import { RoleBasedRoutes } from './routing';
import { initErrorTracking } from './observability/sentry';

initErrorTracking();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders>
      <RoleBasedRoutes />
    </AppProviders>
  </StrictMode>
);
